
import { cloneDeep } from '@/lib';
import { Col, Radio, Row } from 'ant-design-vue';
import {
  computed,
  defineComponent, inject, ref, toRaw,
} from 'vue';

export default defineComponent({
  components: {
    aRow: Row,
    aCol: Col,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
  },
  props: {
    /** 所有选项 */
    pMetas: {
      type: Array,
      default: () => ([]),
    },
    /** 正确选项 */
    pAnswer: {
      type: Number,
      default: () => 0,
    },
    /** 学生答案 */
    stuAnswer: {
      type: Number,
      required: false,
    },
  },
  emits: ['onStuAnswer'],
  setup(props, { emit }) {
    const jobView = inject('jobView'); // 查看类型
    const pMetasList = computed(() => props.pMetas);
    const answer = ref(props.pAnswer);
    const todoStu = ref(props.stuAnswer);
    // console.log(props.stuAnswer, 'stuAnswer-single');
    const todoSave = () => {
      emit('onStuAnswer', [cloneDeep(toRaw(todoStu.value))]);
    };
    return {
      jobView,
      // option,
      answer,
      pMetasList,
      // answer,
      todoStu,
      todoSave,
    };
  },
});
